import script from "./Options.vue?vue&type=script&setup=true&lang=ts"
export * from "./Options.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import qInstall from "../../../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QItemLabel,QItemSection});
